var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.205034 0.205033C0.478412 -0.0683443 0.921646 -0.0683443 1.19502 0.205033L4.00002 3.01001L6.80497 0.205074C7.07835 -0.0683035 7.52159 -0.0683035 7.79497 0.205074C8.06834 0.478451 8.06834 0.921683 7.79497 1.19506L4.99001 4L7.79497 6.80494C8.06834 7.07832 8.06834 7.52155 7.79497 7.79493C7.52159 8.0683 7.07835 8.0683 6.80497 7.79493L4.00002 4.98999L1.19502 7.79497C0.921646 8.06834 0.478412 8.06834 0.205034 7.79497C-0.0683447 7.52159 -0.0683446 7.07836 0.205034 6.80498L3.01003 4L0.205034 1.19502C-0.0683446 0.921642 -0.0683447 0.47841 0.205034 0.205033Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.875f7528f689a38cacbbafafdc468ef9.svg";
export { ForwardRef as ReactComponent };